// Converts a Date to a "mm/dd/yyyy" string
export function dateToMMDDYYYY(date: Date): string {
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();
  return `${mm}/${dd}/${yyyy}`;
}

// Converts a "mm/dd/yyyy" string to a Date, or undefined if invalid
export function mmddyyyyToDate(dateStr: string): Date | undefined {
  const match = /^(\d{1,2})\/(\d{1,2})\/(\d{4})$/.exec(dateStr);
  if (!match) return undefined;

  const month = Number(match[1]);
  const day = Number(match[2]);
  const year = Number(match[3]);

  // Check valid ranges
  if (month < 1 || month > 12 || day < 1 || day > 31) return undefined;

  const date = new Date(year, month - 1, day);

  // Ensure JS didn't auto-correct an invalid date (e.g., 02/30 -> 03/02)
  if (
    date.getFullYear() !== year ||
    date.getMonth() + 1 !== month ||
    date.getDate() !== day
  ) {
    return undefined;
  }

  return date;
}
